import type { SingleIconProps } from "./icon"

const BePickupIcon = (props: SingleIconProps) => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <circle cx="12.5" cy="12" r="12" fill="white" />
      <circle cx="12.5" cy="12" r="10" fill="#1A6CE5" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.75594 16.8904C7.12388 16.8904 7.45582 16.6716 7.60232 16.334C8.04484 15.3141 9.09224 13.2487 10.3174 13.2487L10.0856 13.9555C9.61122 15.4025 10.6892 16.8904 12.212 16.8904C13.1823 16.8904 14.0421 16.2649 14.3409 15.3417L15.3322 12.2785C16.991 11.8262 18.0997 10.2311 19.0856 7.99207C19.3605 7.36786 18.9016 6.66675 18.2195 6.66675C17.8495 6.66675 17.5124 6.88249 17.3596 7.21956C16.0234 10.1685 14.7895 10.9752 12.7054 11.1442C9.98053 11.3611 7.85896 11.5781 5.92702 15.5642C5.62991 16.1772 6.07481 16.8904 6.75594 16.8904ZM13.0636 10.5473C14.0188 10.5473 14.8546 9.77117 14.8546 8.81594C14.8546 7.801 14.0188 7.02495 13.0636 7.02495C12.1084 7.02495 11.3323 7.801 11.3323 8.81594C11.3323 9.77117 12.1084 10.5473 13.0636 10.5473Z"
        fill="white"
      />
    </svg>
  )
}

export { BePickupIcon }
